/** Validates that a request to add a new entry is well-formed. */
export const addEntryRequestIsWellFormed = ({ type, match, choice }) => type && match && choice // TODO: Type-specific validation! e.g. IP, email, PAN, etc
